import PropTypes from 'prop-types';
import { Typography } from 'antd';
import logo from 'assets/images/Logo_INE.png';
import './Footer.scss';

const { Text, Link } = Typography;

export const Footer = ({ view }) => {
  const paddingImgFooter =
    view === 'sistemas' ? { '--pdd-': '0 20px' } : { '--pdd-': '0 20px 0 90px' };

  return (
    <footer className="contenedorFooterSIMAC">
      <img src={logo} className="imgINEFooter" style={paddingImgFooter} alt="LogoFooterINE" />
      <Link underline className="linkCAUFooter" href="https://cau.ine.mx/">
        CAU
      </Link>
      <Text className="infoFooter">
        | Compatibilidad óptima con Google Chrome | © Derechos Reservados, Instituto Nacional
        Electoral, México 1991 al 2024
      </Text>
      <Text className="revisionFooter">{`SIMAC 1.0.0 REV ${process.env.REACT_APP_VERSION}`}</Text>
      <Text className="verFooter">Versión 1.0</Text>
    </footer>
  );
};

Footer.propTypes = {
  view: PropTypes.string.isRequired
};
